<!-- 
/**
 * Auto-Form.vue
 * 
 * Se corrigó la apertura en automático del detalle de la imágen al hacerle click y la visualización constante de la leyenda "Archivo seleccionado" 
 * inputs tipo archivo de imágen.
 * 
 *  @Version 2.0
 *  @Author Daniel Lepe 2020
 * 
 */
-->
<template>
	<b-card class="auto-form">
		<!-- [originId[{{originId}}]]
    [value[{{value}}]]
    [resulting_id[{{resulting_id}}]]
    [conformedURI[{{conformedURI}}]] -->
		<template v-if="wrongConfig">
			<div slot="header">
				<div class="pt-2 pb-2">Hay un error de configuración.</div>
			</div>
			<p>
				Por favor rectifica el origen y que el registro que buscas aún
				exista.
			</p>
		</template>

		<template v-else>
			<div slot="header">
				<div class="pt-2 pb-2">{{ formLabel }}</div>
			</div>

			<spinner v-if="loading" />

			<b-form
				class="animated fadeIn"
				@submit="triggerDataUpdate()"
				v-else
			>
				<b-row>
					<b-col sm="12">
						<b-form-group
							v-for="item in sourceNotHidden"
							:key="item.name"
						>
							<!-- GENERAL LABEL -->
							<label
								v-if="item.type != 'checkbox'"
								:for="item.name"
								>{{ item.label }}</label
							>

							<!-- INPUTS -->
							<template v-if="item.type == 'file'">
								<b-row v-if="originalData[item.name]">
									<b-col no-gutter class="mb-4 pb-1">
										<api-img
											:comp="originalData[item.name]"
										/>
									</b-col>
								</b-row>

								<b-form-file
									:state="Boolean(data[item.name])"
									v-model="data[item.name]"
									:id="item.name"
									v-if="!!!item.readonly"
									:required="item.required"
									placeholder="Select the file or drop it here..."
									drop-placeholder="Drop the file..."
								></b-form-file>

								<div
									class="mt-3"
									v-if="
										!!!item.readonly &&
										data[item.name] &&
										data[item.name].name
									"
								>
									Archivo seleccionado:
									{{
										data[item.name]
											? data[item.name].name
											: ""
									}}
								</div>
							</template>

							<fk-select
								v-else-if="item.type == 'fk'"
								v-model="data[item.name]"
								:edited="dataMD5"
								:item="item"
								:full-data="data"
							></fk-select>

							<b-form-select
								v-else-if="
									item.type == 'selectmultiple' ||
									item.type == 'select'
								"
								v-model="data[item.name]"
								:multiple="item.type == 'selectmultiple'"
								:id="item.name"
								:readonly="item.readonly"
								:required="item.required"
								:options="item.fieldOptions.options"
							></b-form-select>

							<b-form-checkbox
								v-else-if="item.type == 'checkbox'"
								v-model="data[item.name]"
								:id="item.name"
								:readonly="item.readonly"
								:required="item.required"
								value="1"
								unchecked-value="0"
								>{{ item.label }}</b-form-checkbox
							>

							<b-form-input
								v-else
								v-model="data[item.name]"
								:id="item.name"
								:required="item.required"
								:readonly="item.readonly"
							></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>

				<input
					v-for="hiddenItem in sourceHidden"
					:key="hiddenItem.name"
					v-model="data[hiddenItem.name]"
					:type="hiddenItem.type"
					:id="hiddenItem.name"
					:required="hiddenItem.required"
					:readonly="hiddenItem.readonly"
				/>
			</b-form>
		</template>

		<div slot="footer" v-if="maySaved || mayDeleted" class="text-right">
			<template v-if="maySaved">
				<button type="button" @click="reset()" class="btn btn-warning">
					Cancel
					<i class="fa fa-times"></i>
				</button>
				<button
					type="submit"
					class="btn btn-primary ml-3"
					v-if="!loading"
					@click="triggerDataUpdate()"
				>
					Apply
					<i class="fa fa-check"></i>
				</button>
			</template>

			<template v-else-if="mayDeleted">
				<button
					type="button"
					@click="tryDelete()"
					class="btn btn-danger"
				>
					Delete
					<i class="fa fa-trash"></i>
				</button>
			</template>
		</div>
	</b-card>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import fkSelect from "@/views/elements/fk-select.vue";
import md5 from "js-md5";

export default {
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		origin: {
			type: String,
			default: null,
		},
		title: {
			type: String,
			default: "",
		},
	},

	data: () => {
		return {
			edited: 0,
			originId: null,
			wrongConfig: false,
			loading: true,
			originalData: {},
			data: {},
			ghostData: {},
			source: [],
			resulting_id: null,
		};
	},

	components: {
		fkSelect,
	},

	computed: {
		sourceNotHidden() {
			return _.filter(this.source, (item) => {
				if (item.type != "hidden") return item;
			});
		},
		sourceHidden() {
			return _.filter(this.source, (item) => {
				if (item.type == "hidden") return item;
			});
		},
		conformedURI() {
			return (
				this.origin +
				"/" +
				(!!this.resulting_id ? this.resulting_id : this.originId)
			);
		},
		formLabel() {
			return this.title != "" ? this.title : "Auto form";
		},
		mayDeleted() {
			return !this.maySaved && (!!this.resulting_id || !!this.originId);
		},
		maySaved() {
			return (
				JSON.stringify(this.data) != JSON.stringify(this.originalData)
			);
		},
		dataMD5() {
			return md5(JSON.stringify(this.data));
		},
	},

	methods: {
		tryPostingFiles(response) {
			let data = new FormData();
			let count = 0;
			this.resulting_id = response.resulting_id;
			_.forEach(this.data, (postingFile, keyname) => {
				if (
					!!postingFile &&
					(postingFile.type == "image/jpg" ||
						postingFile.type == "image/jpeg" ||
						postingFile.type == "image/png")
				) {
					data.append(keyname, postingFile, postingFile.name);
					count++;
				}
			});
			if (count) {
				axios
					.post(this.conformedURI, data, {
						headers: {
							accept: "application/json",
							"Content-Type": `multipart/form-data; boundary=${data._boundary}`,
						},
					})
					.then(this.updateComponent);
			} else {
				this.updateComponent(response);
			}
		},
		reset() {
			this.loading = true;
			setTimeout(() => {
				this.data = _.cloneDeep(this.originalData);
				this.loading = false;
			}, 100);
		},
		updateComponent(response) {
			if (!!response.source) this.source = response.source;

			if (!!response.originalData)
				this.originalData = response.originalData;

			if (response.status) this.reset();
			else this.loading = false;
		},
		defineFromURI() {
			this.loading = true;
			axios.get(this.conformedURI).then(this.updateComponent);
		},
		triggerDataUpdate() {
			this.loading = true;
			let data2send = {};
			let definition;
			_.forEach(this.source, (item) => {
				if (!item.readonly && item.type != "file")
					data2send[item.name] = null;
			});
			_.forEach(this.data, (value, name) => {
				definition = _.find(this.source, { name });
				if (
					!!definition &&
					!definition.readonly &&
					definition.type != "file"
				)
					data2send[name] = value;
			});
			axios
				.post(
					this.conformedURI,
					_.merge(data2send, { _route: this.$route.params })
				)
				.then(this.tryPostingFiles);
		},
		tryDelete() {
			if (confirm("¿Seguro?")) {
				axios.delete(this.conformedURI).then((r) => {
					this.$router.go(-1);
				});
			}
		},
	},

	beforeMount() {
		this.originId = this.value;
		if (!this.origin) {
			this.wrongConfig = true;
		}
	},

	mounted() {
		if (!this.wrongConfig) this.defineFromURI();
	},

	watch: {
		value() {
			this.originId = this.value;
		},
		resulting_id() {
			this.$emit("input", this.resulting_id);
		},
	},
};
</script>